export default __webpack_public_path__ + "static/media/less.4dfd09c0.png";